import React, { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { useMediaQuery } from "react-responsive";
import axios from "axios";
import { API_BASE_URL, RECAPTCHA_SITE_KEY } from "@utils/constant";
import { SubmitHandler, useForm } from "react-hook-form";
import { Fade } from "react-awesome-reveal";
import ThankYou from "@pages/contact/parts/thank-you";
import { triggerEachFormTracker } from "@utils/helper";

// const brands = [
//   { src: "/assets/images/kwikcheckoutcod/lakme.png", alt: "Lakme" },
//   { src: "/assets/images/kwikcheckoutcod/boat.png", alt: "Boat" },
//   { src: "/assets/images/kwikcheckoutcod/limeroad.png", alt: "Limeroad" },
//   { src: "/assets/images/kwikcheckoutcod/neemans.png", alt: "Neemans" },
//   { src: "/assets/images/kwikcheckoutcod/firebolt.png", alt: "Firebolt" },
//   { src: "/assets/images/kwikcheckoutcod/lenskart.png", alt: "Lenskart" },
//   { src: "/assets/images/kwikcheckoutcod/itc.png", alt: "ITC" },
//   { src: "/assets/images/kwikcheckoutcod/mamaearth.png", alt: "MamaEarth" },
// ];

const platformOptions = [
  {
    name: "<500",

  },
  {
    name: "500-1000",

  },
  {
    name: "1000+",

  },
];

const SectionOne: React.FC<any> = () => {
  const params = new URLSearchParams(window.location.search);
  // export const SectionOne = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const recaptchaRef = React.useRef<ReCAPTCHA>();

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    brand_url: "",
    no_of_transaction: null,
    g_recaptcha_token: ""
  });

  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const { handleSubmit, getValues } = useForm({});

  // const { data, params } = props;

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    // Allow only + and digits in mobile
    if (name === "mobile" && /[^\d+]/.test(value)) return;

    if (name === "daily_order") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
        sub_platform: "",
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    // Clear error for field
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const newErrors: typeof errors = {};
    if (!formData.name.trim())
      newErrors.name = "Full name is required.";

    // if (!formData.no_of_transaction.trim())
    //   newErrors.no_of_transaction = "Daily Order is required.";

    if (!formData.mobile.trim())
      newErrors.mobile = "Phone number is required.";
    else if (!/^\+?\d{7,15}$/.test(formData.mobile.trim()))
      newErrors.mobile = "Enter a valid Phone number.";

    if (!formData.email.trim()) newErrors.email = "Email Id is required.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email.trim()))
      newErrors.email = "Enter a valid email id.";

    if (!formData.brand_url.trim()) {
      newErrors.brand_url = "Ecommerce Store Link is required.";
    }




    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };



  const handleRecaptchaChange = (value) => {
    formData.g_recaptcha_token = value;
    // formData.daily_order = getValues("daily_order");
    // formData.sub_platform = getValues("sub_platform");
    axios
      .post(API_BASE_URL + "form/ke-india-form", formData)
      .then(function (response) {
        setSuccessMessage("Demo booked successfully!");
        triggerEachFormTracker(formData)
        setFormData({
          name: formData.name,
          mobile: "",
          email: "",
          brand_url: "",
          no_of_transaction: null,
          g_recaptcha_token: ""
        });
      })
      .catch(function (error) {
        setLoading(false);
        console.log(error.response.data?.errors["product[]"]);
        setErrors(error?.response?.data?.errors);
      });
  };

  const handleRecaptchaSubmit = async () => {
    // Trigger the reCAPTCHA challenge
    recaptchaRef.current.execute();
  };

  const onSubmit: SubmitHandler<any> = async (data) => {
    // if (!data.product) {
    //   data.product = [];
    // }
    setSuccessMessage("");
    if (!validateForm()) return;

    data.source = params.get("utm_source");
    data.medium = params.get("utm_medium");
    data.campaign = params.get("utm_campaign");

    data.campaignid = params.get("campaignid");
    data.adgroupid = params.get("adgroupid");
    data.keyword = params.get("keyword");
    data.utm_term = params.get("utm_term");
    data.gad_source = params.get("gad_source");
    data.gad_campaignid = params.get("gad_campaignid");
    data.gbraid = params.get("gbraid");
    data.gclid = params.get("gclid");
    setFormData(prevData => ({
      ...prevData,
      ...data
    }));
    handleRecaptchaSubmit();
  };


  return (
    <div className="sectionke-Ind">
      <div className="container-fluid">
        <div className="row banner align-items-center" >
          <div className="col-lg-6 col-md-12 banner-left" style={{ marginLeft: isMobile ? '0.2rem' : "5rem" }}>
            <div className="heading-Ind1">

              <h1 style={{ fontWeight: "400", fontSize: "clamp(38px, 6vw, 64px)", maxWidth:"500px" }}>
                Burning cash on Meta ads and still not seeing ROAS?
              </h1>

              <div >
                {[
                  "Identify upto 25% anonymous website visitors instantly with KwikPass",
                  "Retarget & convert them across WhatsApp, Email & SMS via personalized journeys.",
                  "Join 10,000+ D2C brands who achieved up to 20X ROAS"
                ].map((text, idx) => (
                  <div key={idx} className="mt-3 second" style={{display:"flex", alignItems:"flex-start"}}>
                    <img
                      style={{marginTop:"2px"}}
                      src="/assets/images/keinternational/check.png"
                      alt=""
                    />
                    <span className="mx-2" style={{ fontSize: 'clamp(16px, 4vw, 21px)', color: '#000428',maxWidth:"415px"}}>{text}</span>
                  </div>
                ))}
              </div>


            </div>
          </div>

          <div className="col-lg-5 col-md-12 banner-right mt-4 mt-lg-0">
            <div style={{ marginLeft: "50px" }}>
              <div className="form-wrapper1-Ind" style={{ width: isMobile ? "90%" : "95%" }}>
                <div className="form-container1-Ind">
                  {successMessage && (
                    <Fade direction="right">
                      <ThankYou name={formData?.name} />
                    </Fade>
                  )}
                  {
                    !successMessage &&
                    <form
                      className="demo-form1-Ind"
                      onSubmit={handleSubmit(onSubmit)}
                      noValidate
                    >

                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#f2f2f2",
                          border: "none",
                          borderRadius: "8px",
                          padding: "14px 16px",
                          fontSize: "14px",
                          width: "100%",
                          color: "#333",
                        }}
                        placeholder="Full Name"
                      />
                      {errors.name && (
                        <p className="error" style={{ color: "red" }}>
                          {errors.name}
                        </p>
                      )}

                      <input
                        type="tel"
                        id="mobile"
                        name="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#f2f2f2",
                          border: "none",
                          borderRadius: "8px",
                          padding: "14px 16px",
                          fontSize: "14px",
                          width: "100%",
                          color: "#333",
                        }}
                        placeholder="Phone Number"
                      />
                      {errors.mobile && (
                        <p className="error" style={{ color: "red" }}>
                          {errors.mobile}
                        </p>
                      )}

                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#f2f2f2",
                          border: "none",
                          borderRadius: "8px",
                          padding: "14px 16px",
                          fontSize: "14px",
                          width: "100%",
                          color: "#333",
                        }}
                        placeholder="Email Id"
                      />
                      {errors.email && (
                        <p className="error" style={{ color: "red" }}>
                          {errors.email}
                        </p>
                      )}

                      <input
                        type="url"
                        id="brand_url"
                        name="brand_url"
                        value={formData.brand_url}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#f2f2f2",
                          border: "none",
                          borderRadius: "8px",
                          padding: "14px 16px",
                          fontSize: "14px",
                          width: "100%",
                          color: "#333",
                        }}
                        placeholder="Ecommerce Store link"
                      />
                      {errors.brand_url && (
                        <p className="error" style={{ color: "red" }}>
                          {errors.brand_url}
                        </p>
                      )}

                      {/* <select
                        id="daily_order"
                        name="daily_order"
                        // value={formData.daily_order}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#f2f2f2",
                          border: "none",
                          padding: "14px 16px",
                          fontSize: "14px",
                          width: "100%",
                          color: "#333",
                        }}
                        // placeholder="Montly Orders"
                      >
                        <option value="" style={{ color: "#333", }}>Daily Orders</option>
                        {platformOptions.map((opt) => (
                          <option key={opt.name} value={opt.name}>
                            {opt.name}
                          </option>
                        ))}
                      </select>
                      {errors.daily_order && (
                        <p className="error" style={{ color: "red" }}>
                          {errors.daily_order}
                        </p>
                      )} */}


                      <input
                        type="number"
                        id="no_of_transaction"
                        name="no_of_transaction"
                        value={formData.no_of_transaction}
                        onChange={handleChange}
                        style={{
                          backgroundColor: "#f2f2f2",
                          border: "none",
                          borderRadius: "8px",
                          padding: "14px 16px",
                          fontSize: "14px",
                          width: "100%",
                          color: "#333",
                        }}
                        placeholder="Daily Order"
                      />
                      {errors.name && (
                        <p className="error" style={{ color: "red" }}>
                          {errors.no_of_transaction}
                        </p>
                      )}

                      <ReCAPTCHA
                        ref={recaptchaRef as React.RefObject<ReCAPTCHA>}
                        sitekey={RECAPTCHA_SITE_KEY}
                        size="invisible"
                        onChange={handleRecaptchaChange}
                      />

                      <button type="submit" disabled={loading} style={{ borderRadius: "5px" }}>
                        {loading ? "Submitting..." : "Book a Demo"}
                      </button>
                      {successMessage && (
                        <p className="success">{successMessage}</p>
                      )}
                    </form>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
    </div>
  );
}
export default SectionOne